export default __webpack_public_path__ + "static/media/Delete.33a83080.svg";